import { FaCrown, FaCalendarAlt, FaTag } from 'react-icons/fa';
import { Card, CardBody, Badge } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import './PlanCard.css';
import { tField } from '../../utils/helpers';
import { useTranslation } from 'react-i18next';

function PlanCard({plan}) {
  const { t } = useTranslation('plans');
  const navigate = useNavigate();

  return(
    <Card 
      className="plan-card-container position-relative border-0 shadow-sm overflow-hidden h-100"
      onClick={() => navigate(`/plans/view/${plan.id}`, { state: { plan } })}
    >
      {/* Decorative elements */}
      <div className="plan-card-decorative-top"></div>
      <div className="plan-card-decorative-bottom"></div>
      
      {/* Special badge */}
      <div className="plan-card-badge d-inline-block">
        <div className="plan-card-badge-content d-flex align-items-center gap-2">
          <FaCrown className="text-white" size={16} />
          <span className="plan-card-badge-text">
            { tField(plan, 'name') }
          </span>
        </div>
      </div>
      
      <CardBody className="p-4">
        {/* Header */}
        <div className="plan-card-header">
          <div className="d-flex align-items-center gap-2 text-secondary plan-card-header-text">
            <FaCalendarAlt className="text-primary" size={18} />
            <span>إعلان - {plan.months_count} شهور</span>
          </div>
        </div>
        
        {/* Price and Discount */}
        <div className="d-flex justify-content-between align-items-center">
          {/* Price */}
          <div className="text-end">
            <div className="d-flex align-items-baseline">
              <span className="plan-card-price">
                {plan.price}
              </span>
              <span className="plan-card-currency">
                { t('currency') }
              </span>
            </div>
          </div>
          
          {/* Discount Badge */}
          <Badge className="plan-card-discount-badge d-flex align-items-center gap-1">
            <FaTag size={12} />
            { plan.discount }% { t('discount') }
          </Badge>
        </div>
      </CardBody>
    </Card>
  );
}

export default PlanCard;